document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bundle-editor]').forEach(editor => {
    const form = editor.closest('form');
    const gallery = form.closest('[data-product-root]').querySelector('[data-product-gallery]');
    const preview = editor.querySelector('[data-bundle-preview]');
    const round = gallery.querySelector('[data-round-gallery-preview]');
    const slot = editor.querySelector('[data-bundle-ornament]');
    slot.append(round);
    gallery.querySelector('[data-preview-stage]').append(preview);
    const adjust = editor.querySelector('[data-canvas-adjust]'); gallery.append(adjust);
    const input = form.querySelector('#CanvasArtwork');
    const canvas = editor.querySelector('[data-bundle-canvas]') || preview.querySelector('canvas');
    const ctx = canvas.getContext('2d');
    const zoom = adjust.querySelector('[data-canvas-zoom]');
    const x = adjust.querySelector('[data-canvas-x]'); const y = adjust.querySelector('[data-canvas-y]');
    const quality = adjust.querySelector('[data-canvas-quality]');
    const output = editor.querySelector('[data-canvas-file]'); const crop = editor.querySelector('[data-canvas-crop]');
    const error = editor.querySelector('[data-canvas-error]');
    const settings = JSON.parse(editor.querySelector('[data-bundle-settings]').textContent);
    let image = null, url = null, generation = 0, revision = 0, submitting = false, busy = false;
    const active = () => Boolean(image && !form.querySelector('[data-reuse-artwork]')?.checked);
    const refresh = () => {
      revision++; output.value = ''; output.disabled = true; crop.disabled = !active();
      const enabled = active(); const ornament = !round.hidden;
      const visible = (enabled || ornament) && !form.querySelector('[data-reuse-artwork]')?.checked;
      preview.hidden = !visible; gallery.classList.toggle('product-gallery--bundle-preview', visible);
      preview.querySelector('[data-ornament-placeholder]').hidden = ornament;
      preview.querySelector('[data-canvas-placeholder]').hidden = enabled;
      canvas.hidden = !enabled; adjust.hidden = !enabled;
      if (!enabled) return;
      const scale = Math.max(2400 / image.naturalWidth, 3000 / image.naturalHeight) * Number(zoom.value) / 100;
      const w = image.naturalWidth * scale, h = image.naturalHeight * scale;
      const dx = (w - 2400) / 2 * Number(x.value) / 100;
      const dy = (h - 3000) / 2 * Number(y.value) / 100;
      ctx.clearRect(0,0,2400,3000); ctx.drawImage(image,(2400-w)/2+dx,(3000-h)/2+dy,w,h);
      const dpi = Math.floor(300/scale);
      quality.textContent = `${settings.quality}: ${dpi >= 300 ? settings.good : dpi >= 150 ? settings.medium : settings.low} (${dpi} DPI)`;
      crop.value = `8x10 portrait; zoom ${zoom.value}%; horizontal ${x.value}; vertical ${y.value}; ${dpi} DPI`;
    };
    form.addEventListener('beese:ornament-preview', refresh);
    form.addEventListener('change', refresh);
    [zoom,x,y].forEach(control => control.addEventListener('input', refresh));
    adjust.querySelector('[data-canvas-reset]').addEventListener('click', () => { zoom.value=100;x.value=0;y.value=0;refresh(); });
    input.addEventListener('change', async () => {
      const token = ++generation; image = null; error.hidden=true; if(url) URL.revokeObjectURL(url); refresh();
      const file = input.files?.[0]; if(!file || !['image/jpeg','image/png','image/webp'].includes(file.type)) return;
      url=URL.createObjectURL(file); const next = new Image();next.src=url;
      try { await next.decode();if(token!==generation)return;image=next;zoom.value=100;x.value=0;y.value=0;refresh(); }
      catch { if(token===generation)error.hidden=false; }
    });
    form.exportBundleCanvas = async () => {
      if(!active())return;
      const start=revision;
      const blob=await new Promise(resolve=>canvas.toBlob(resolve,'image/png'));
      if(!blob || start!==revision || !active())throw new Error(error.textContent);
      const transfer=new DataTransfer();transfer.items.add(new File([await form.encodePrintPng(blob)],'beese-8x10-canvas.png',{type:'image/png'}));output.files=transfer.files;output.disabled=false;
    };
    form.addEventListener('submit', async event => {
      if(event.defaultPrevented || submitting || !active() || !round.hidden)return;
      event.preventDefault();if(busy)return;busy=true;error.hidden=true;
      try {await form.exportBundleCanvas();submitting=true;form.requestSubmit(event.submitter||undefined);submitting=false;}
      catch {submitting=false;output.disabled=true;error.hidden=false;}finally{busy=false;}
    });
    refresh();
  });
});

